<script lang="ts">
	import { invalidate } from '$app/navigation'
	import Header from '$lib/components/Header.svelte'
	import Notice from '$lib/components/Notice.svelte'
	import Subscribe from '$lib/components/Subscribe.svelte'
	import Discord from '$lib/svg/Discord.svelte'
	import Github from '$lib/svg/Github.svelte'
	import Instagram from '$lib/svg/Instagram.svelte'
	import Logo from '$lib/svg/Logo.svelte'
	import Twitter from '$lib/svg/Twitter.svelte'
	import Youtube from '$lib/svg/Youtube.svelte'
	import { onMount } from 'svelte'

	export let data

	$: ({ supabase, session } = data)

	onMount(() => {
		const {
			data: { subscription },
		} = supabase.auth.onAuthStateChange((event, _session) => {
			if (_session?.expires_at !== session?.expires_at) {
				invalidate('supabase:auth')
			}
		})
		return () => subscription.unsubscribe()
	})
</script>

<svelte:head>
	<script
		defer
		data-domain="scenery.io"
		event-session={session ? true : false}
		src="https://plausible.io/js/script.file-downloads.tagged-events.pageview-props.outbound-links.js"
	></script>
</svelte:head>

<div class="flex flex-col h-full">
	<Header {data} />
	<main class="flex flex-col flex-grow pb-24 pt-16">
		<Notice />
		<slot />
	</main>
	<footer class="flex flex-col gap-4 p-8" style="margin-top: min(auto, 20vh)">
		<div class="flex justify-center flex-wrap gap-9 sm:justify-between">
			<div
				class="flex flex-col justify-center sm:justify-between items-center sm:items-start gap-4 sm:gap-9"
			>
				<a href="/" class="h-8 inline-block">
					<Logo />
				</a>
				<div class="flex gap-5">
					<a href="/terms" class="hover:underline">Terms</a>
					<a href="/privacy" class="hover:underline">Privacy</a>
					<a href="/license" class="hover:underline">License</a>
					<a href="/support" class="hover:underline">Support</a>
				</div>
			</div>
			<div
				class="flex flex-col justify-between items-center sm:items-end gap-6 sm:gap-9"
			>
				<Subscribe />
				<div class="flex gap-2.5 items-center text-foreground">
					<a
						href="https://twitter.com/scenery_io"
						class="hover:text-primary"><Twitter /></a
					>
					<a
						href="https://instagram.com/scenery__io_"
						class="hover:text-primary"><Instagram /></a
					>
					<a
						href="https://youtube.com/@scenery-io"
						class="hover:text-primary"><Youtube /></a
					>
					<a
						href="https://github.com/scenery-io"
						class="hover:text-primary"><Github /></a
					>
					<a
						href="https://discord.com/invite/dAmKYcfaff"
						class="hover:text-primary"><Discord /></a
					>
				</div>
			</div>
		</div>
		<div class="text-muted-foreground mt-16 text-sm text-center">
			Copyright © 2023 Scenery. All rights reserved. Scenery is not
			affiliated with Scene Group Ltd.
		</div>
	</footer>
</div>

<style>
	@import '$lib/styles/fonts.css';

	:global(body) {
		@apply bg-background;
	}
</style>
